import { render, staticRenderFns } from "./group.vue?vue&type=template&id=b3482bb4&scoped=true&"
import script from "./group.vue?vue&type=script&lang=js&"
export * from "./group.vue?vue&type=script&lang=js&"
import style0 from "./group.vue?vue&type=style&index=0&id=b3482bb4&scoped=true&lang=css&"
import style1 from "./group.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3482bb4",
  null
  
)

export default component.exports